/**
 * Iter 96 — one shared booking-status → badge mapping so Admin, Vendor and
 * Customer surfaces all use identical colors and wording (spec §5).
 * `bookingDisplayStatus` derives operational states (Active Rental /
 * Return Due) from a confirmed booking's dates in Albania local time.
 */
import { tiranaDateStr } from "@/components/bookings/TodayBookingFilters";

export const STATUS_META = {
  pending:             { label: "Pending",           cls: "bg-sky-100 text-sky-800 border-sky-200" },
  pending_approval:    { label: "Pending Approval",  cls: "bg-amber-100 text-amber-800 border-amber-200" },
  pending_payment:     { label: "Awaiting Payment",  cls: "bg-yellow-100 text-yellow-800 border-yellow-300" },
  host_accepted:       { label: "Ready for Pickup",  cls: "bg-teal-100 text-teal-800 border-teal-200" },
  confirmed:           { label: "Confirmed",         cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  active:              { label: "Active Rental",     cls: "bg-blue-100 text-blue-800 border-blue-200" },
  return_due:          { label: "Return Due",        cls: "bg-orange-100 text-orange-800 border-orange-300" },
  completed:           { label: "Completed",         cls: "bg-slate-100 text-slate-700 border-slate-200" },
  cancelled:           { label: "Cancelled",         cls: "bg-rose-100 text-rose-800 border-rose-200" },
  declined_by_host:    { label: "Declined",          cls: "bg-neutral-100 text-neutral-600 border-neutral-200" },
  expired_no_response: { label: "Expired",           cls: "bg-neutral-100 text-neutral-600 border-neutral-200" },
  no_show:             { label: "No Show",           cls: "bg-violet-100 text-violet-800 border-violet-300" },
  refunded:            { label: "Refunded",          cls: "bg-amber-50 text-amber-800 border-amber-200" },
};

export function bookingDisplayStatus(b) {
  const s = (b?.status || "").toLowerCase();
  if (s !== "confirmed") return s;
  const t = tiranaDateStr();
  const start = String(b.start_date || "").slice(0, 10);
  const end = String(b.end_date || "").slice(0, 10);
  if (end && end < t) return "return_due";
  if (start && end && start <= t && t <= end) return "active";
  return "confirmed";
}

export default function BookingStatusBadge({ booking, status, className = "" }) {
  const key = status || bookingDisplayStatus(booking);
  const meta = STATUS_META[key] || { label: key || "—", cls: "bg-neutral-100 text-neutral-600 border-neutral-200" };
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-[11px] font-bold ${meta.cls} ${className}`}
      data-testid={`status-badge-${key}`}
      data-booking-status={key}
    >
      {meta.label}
    </span>
  );
}
